// extracted by mini-css-extract-plugin
export default {"divider":"adc__divider--e357x","content":"adc__content--lYbeK","title":"adc__title--FFC1I"};